import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';

import { Box, Type, Button } from '@nerdwallet/currency';
import analytics from '@nerdwallet/analytics';
import { trackInteraction } from '../../../lib/analytics-helpers';

import styles from './vertical-comparison.module.less';

const VerticalComparisonTab = ({
  id,
  subtitle,
  description,
  primaryButtonText,
  primaryButtonUrl,
  secondaryButtonText,
  secondaryButtonUrl,
}) => {
  const primaryEntityName = `hp_${id}_tab_primary_cta_clicked`;
  const primaryImpressionId = analytics.uuid();

  const secondaryEntityName = `hp_${id}_tab_secondary_cta_clicked`;
  const secondaryImpressionId = analytics.uuid();

  return (
    <Box className={classNames(styles.backgroundImage)}>
      <Box className={classNames(styles.contentWrapper)}>
        <Box className={classNames(styles.contentBox)}>
          <Type bold className={classes('margin-bottom-3')}>
            {subtitle}
          </Type>
          <Type className={classes('margin-bottom-4')}>{description}</Type>
          <div className={styles.buttonWidth}>
            <Button
              primary
              block
              href={primaryButtonUrl}
              onClick={() =>
                trackInteraction(primaryEntityName, primaryImpressionId)
              }
            >
              {primaryButtonText}
            </Button>
          </div>
          <div className={styles.buttonWidth}>
            <Button
              secondary
              block
              href={secondaryButtonUrl}
              onClick={() =>
                trackInteraction(secondaryEntityName, secondaryImpressionId)
              }
            >
              {secondaryButtonText}
            </Button>
          </div>
        </Box>
      </Box>
    </Box>
  );
};

VerticalComparisonTab.propTypes = {
  id: PropTypes.string,
  subtitle: PropTypes.string,
  description: PropTypes.string,
  primaryButtonText: PropTypes.string,
  primaryButtonUrl: PropTypes.string,
  secondaryButtonText: PropTypes.string,
  secondaryButtonUrl: PropTypes.string,
};

VerticalComparisonTab.displayName = 'VerticalComparisonTab';

export default VerticalComparisonTab;
